import ICONS from "../icons";

export const PillarSection = ({ pillar, scrollToSection }) => {
  const PillarIcon = ICONS[pillar.icon];
  return (
    <section
      className="section pillar"
      id={pillar.id}
      style={{ "--pillar-accent": pillar.accent }}
      data-testid={`pillar-section-${pillar.id}`}
    >
      <div className="pillar-heading" data-testid={`pillar-heading-${pillar.id}`}>
        <div className="pillar-heading-copy">
          <span className="pillar-kicker" data-testid={`pillar-kicker-${pillar.id}`}>
            <PillarIcon className="pillar-kicker-icon" aria-hidden="true" />
            {pillar.kicker}
          </span>
          <h2 data-testid={`pillar-title-${pillar.id}`}>{pillar.title}</h2>
          <p data-testid={`pillar-intro-${pillar.id}`}>{pillar.intro}</p>
          <button
            className="cta-button pillar-cta"
            style={{ background: pillar.accent, color: pillar.ctaText }}
            onClick={() => scrollToSection("contact")}
            data-testid={`pillar-cta-${pillar.id}`}
          >
            {pillar.ctaLabel}
          </button>
        </div>
      </div>
      <div className="feature-grid" data-testid={`pillar-feature-grid-${pillar.id}`}>
        {pillar.features.map((feature) => {
          const FeatureIcon = ICONS[feature.icon];
          return (
            <div
              className="feature-card"
              key={feature.title}
              data-testid={`pillar-feature-${pillar.id}-${feature.title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <span className="feature-icon" aria-hidden="true">
                <FeatureIcon />
              </span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
